import { t } from "i18next";
import { AddressInputInbuilt } from "../../components/AddressInputInbuilt";
import { formFields } from "./form-config";
import FormItem from "../../components/FormItem";
import { SimpleTextCell, ArrayNamesCell, SimpleHeader } from "./Components";
import DateRangePickerFilter from "../../components/Filters/DateRangePickerFilter/DateRangePickerFilter";
import { TextFilter } from "../../components/Filters/TextFilter";
import { SelectSimpleObject } from "../../components/Filters/ObjectFilter";
import SelectSimpleInbuilt from "../../components/SelectSimple/Filters/SelectSimpleInbuilt";
import { cancelCauses } from "../../components/Modals/ModalConfirmPageWithCheckbox";
export const getColumns = ({ control, columnsFromStorage, writeSearchDataToSessionStorage }) => {
  return [
    {
      id: formFields.reactionDateTime,
      numeric: false,
      enableSorting: false,
      size: "280px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.reactionDateTime],
      RowCell: (props) => <SimpleTextCell {...props} type="dateTime" />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.reactionDateTime}`}
          sx={{ width: "280px" }}
          input={(props) => (
            <DateRangePickerFilter
              placeholder={t("placeholder:dateRange")}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="reactiondateRangeStorage"
              storageName="tasksListSearchParams"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.facility,
      numeric: false,
      enableSorting: false,
      label: t("label:objects_available_employee"),
      size: "180px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.facility],
      RowCell: (props) => <SimpleTextCell {...props} withTooltip={true} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.facilityId}`}
          label={t("label:object")}
          input={(props) => (
            <SelectSimpleObject
              {...props}
              showSearch
              IsTableheader={true}
              className="select-in-table small-light"
              name={`${formFields.searchParams}.${formFields.facilityId}`}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="protectionObjectIdStorage"
            />
          )}
        />
      ),
    },
    {
      id: formFields.facilityAddress,
      numeric: false,
      enableSorting: false,
      size: "275px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.facilityAddress],
      HeaderCell: () => (
        <FormItem
          control={control}
          sx={{ width: "300px" }}
          placeholder={t("tableHeader:address")}
          name={`${formFields.searchParams}.${formFields.searchAddress}`}
          input={(props) => (
            <AddressInputInbuilt
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchAddressStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: "messageClass",
      numeric: false,
      enableSorting: false,
      size: "200px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.messageClass],
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          placeholder={t("tableHeader:messageClass")}
          name={`${formFields.searchParams}.${formFields.messageClass}`}
          input={(props) => (
            <TextFilter
              className="select_in_built small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchmessageClassStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: "messageCodeName",
      numeric: false,
      enableSorting: false,
      size: "200px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.messageCodeName],
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          placeholder={t("tableHeader:messageCodeName")}
          name={`${formFields.searchParams}.${formFields.messageCodeName}`}
          input={(props) => (
            <TextFilter
              className="select_in_built small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchMessageCodeNameStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.plume,
      numeric: false,
      enableSorting: false,
      label: t("tableHeader:roomAddressPlume"),
      size: "220px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.roomAddressPlume],
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.plume}`}
          sx={{ padding: "12px 0" }}
          input={(props) => (
            <TextFilter
              placeholder={t("tableHeader:plume")}
              className="select_in_built small-light"
              bgcolor={"var(--bgLightGrey)"}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchplumeStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.protectedObjectIntegrNumber,
      numeric: false,
      enableSorting: false,
      label: t("tableHeader:task"),
      size: "250px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.protectedObjectIntegrNumber],
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.protectedObjectIntegrNumber}`}
          input={(props) => (
            <TextFilter
              placeholder="Интеграционный номер"
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="protectedObjectIntegrNumberStorage"
              storageName="magazineEventsListSearchParams"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.channel,
      numeric: false,
      enableSorting: false,
      size: "250px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.channel],
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.channel}`}
          input={(props) => (
            <TextFilter
              placeholder={t("tableHeader:channel")}
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="channelStorage"
              storageName="magazineEventsListSearchParams"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.line,
      numeric: false,
      enableSorting: false,
      size: "250px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.line],
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.line}`}
          input={(props) => (
            <TextFilter
              placeholder={t("tableHeader:line")}
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="lineStorage"
              storageName="magazineEventsListSearchParams"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.chapter,
      numeric: false,
      enableSorting: false,
      size: "250px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.chapter],
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.chapter}`}
          input={(props) => (
            <TextFilter
              placeholder={t("tableHeader:chapter")}
              className="select-in-table small-light"
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="chapterStorage"
              storageName="magazineEventsListSearchParams"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.triggerCauseDisp,
      numeric: false,
      enableSorting: false,
      size: "200px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.triggerCause],
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.triggerCauseDisp}`}
          sx={{ padding: "12px 0" }}
          input={(props) => (
            <TextFilter
              placeholder={t("tableHeader:triggerCause")}
              className="select_in_built small-light"
              bgcolor={"var(--bgLightGrey)"}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchtriggerCauseStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.reasonType,
      numeric: false,
      enableSorting: false,
      size: "200px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.reasonType],

      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          name={`${formFields.searchParams}.${formFields.reasonType}`}
          input={(props) => (
            <SelectSimpleInbuilt
              {...props}
              options={cancelCauses}
              label={t("tableHeader:reasonType")}
              placeholder={t("tableHeader:reasonType")}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchreasonTypeStorage"
              className="select-in-table small-light"
            />
          )}
        />
      ),
    },
    {
      id: "controlConsoleName",
      numeric: false,
      enableSorting: false,
      label: t("tableHeader:controller"),
      size: "150px",
      clickable: false,
      isVisible: columnsFromStorage["controlConsoleName"],
      RowCell: (props) => <SimpleTextCell {...props} />,
      HeaderCell: () => (
        <FormItem
          control={control}
          placeholder={t("tableHeader:controlConsoleName")}
          name={`${formFields.searchParams}.${formFields.controlConsoleName}`}
          sx={{ padding: "12px 0" }}
          input={(props) => (
            <TextFilter
              className="select_in_built small-light"
              bgcolor={"var(--bgLightGrey)"}
              writeSearchDataToSessionStorage={writeSearchDataToSessionStorage}
              storageValue="searchcontrolConsoleNameStorage"
              {...props}
            />
          )}
        />
      ),
    },
    {
      id: formFields.responsibleCustomerUsers,
      numeric: false,
      enableSorting: false,
      label: t("tableHeader:r_organization"),
      size: "250px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.responsibleCustomerUsers],
      RowCell: (props) => <ArrayNamesCell {...props} />,
      HeaderCell: () => <SimpleHeader name={t("tableHeader:r_organization")} />,
    },
    {
      id: formFields.executiveUsers,
      numeric: false,
      enableSorting: false,
      label: t("tableHeader:executive"),
      size: "250px",
      clickable: false,
      isVisible: columnsFromStorage[formFields.executiveUsers],
      RowCell: (props) => <ArrayNamesCell {...props} />,
      HeaderCell: () => <SimpleHeader name={t("tableHeader:executive")} />,
    },
  ].filter(({ isVisible }) => isVisible);
};
